import * as Preact from "preact"
import GameAnalytics from "@fae/source/analytics.js"

import App from "@fae/source/models/App.js"
import Stage from "@fae/source/models/Stage.js"
import Unit from "@fae/source/models/Unit.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Elements from "@fae/source/data/elements.js"

import * as PlotFlourishes from "@fae/source/data/plot/flourishes.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

function canTarget({performerKey, stage, position}) {
    const performer = stage.units[performerKey]
    const target = Stage.findUnitByPosition(stage, position)
    if(target == undefined) return false
    if(target.key == performer.key) return false
    if(target.affiliation == undefined) return false
    if(target.affiliation == "none") return false
    if(target.affiliation == "nothing") return false // TODO: should this be a check for type == "thing"??
    return true
}

// 2 is movement, 3 is waiting, 4 is most skills, 5+ is a priority skill.
// 0 is default, 0.1 and 0.2 are used for stacking can-not-target skills - we generally want attack skills to have precedent over pushpull skills.
function getSupportPriority({performerKey, stage, position}) {
    const performer = stage.units[performerKey]
    const target = Stage.findUnitByPosition(stage, position)
    if(target == undefined) return 0.1
    if(target != undefined
    && target.affiliation == performer.affiliation) {
        return 5
    } else {
        return 4
    }
}

import {Power} from "@fae/source/data/games/ember/views/Description.jsx"
class Underlined {
    render() {
        return (
            <span class="Underlined">
                {this.props.children}
            </span>
        )
    }
}

let skills = {}

skills["attack"] = {
    "key": "attack",
    "name": "Attack",
    "role": "damage",

    "type": "invoke",

    "canBeCounterattacked": true,
    "canCounterattack": ({performerKey, stage, position}) => {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(performer?.ai?.isNotCounterattacking == true) return false
        if(target != undefined && target.affiliation == performer.affiliation) return false // TODO: fix this for pirates
        return true
    },

    "isRenderedEvenIfCanNotTarget": true,

    "power": 0, // will default to the player's power.
    "isIgnoringArmor": false,
    "isIgnoringElements": false,

    // "isHidden": true,

    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(performer.ai?.behaviors?.includes("can attack plants") && target.role == "plant") return true
        if(performer.ai?.behaviors?.includes("can attack flames") && target.role == "flame") return true
        if(target.affiliation == "none") return false
        if(target.affiliation == "nothing") return false
        // if(target.affiliation == undefined) return false
        if(target.type == "thing") return false
        if((performer.canAttackAllies != true && performer.canBetray != true) && target.affiliation == performer.affiliation) return false
        if(performer.ai?.behaviors?.includes("never attacks player") && target.affiliation == stage.player.affiliation) return false
        if(performer.energy["act"] != true) return false // you can cancel an attack by removing their energy

        const targetKey = target.key
        if(performer.oaths instanceof Array) {
            const brokenOath = performer.oaths.find((oath) => {
                if(oath == undefined) return undefined
                if(oath.canAttack instanceof Function) {
                    return oath.canAttack({
                        "stage": stage,
                        "position": position,
                        "performerKey": performer.key,
                        "targetKey": target.key,
                    }) == false
                }
            })
            if(brokenOath != undefined) {
                return false
            }
        }

        return true
    },
    "getPriority": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return 0.2
        if(target.affiliation != performer.affiliation) return 5.2
        if(target.properties?.includes("can be pacified")) return 5
        return 4
    },

    "calculateStep": function({stage, position, performerKey, effectKey, itemKey, isNotPerceivedByAI}) {
        const steps = []

        let performer = stage.units[performerKey]
        let target = Stage.findUnitByPosition(stage, position)

        const direction = Geometry.direction(position, performer.position)
        // const distance = Geometry.distance(position, performer.position)

        // Pre-Attack Dialogue //
        if(performer.scripts != undefined
        && performer.scripts["attack"] != undefined) {
            steps.push(...Stage.processEventSteps(stage, performer.scripts["attack"]))

            if(steps[steps.length - 1] != undefined
            && steps[steps.length - 1].omegastage != undefined) {
                stage = steps[steps.length - 1].omegastage
            }
        }
        stage.scripts.forEach((condition) => {
            if(condition.trigger == "before attacking"
            && condition.canBeTriggered(stage, performer, target) == true
            && condition.events != undefined) {

                steps.push(...Stage.processEventSteps(stage, condition.events))

                if(steps[steps.length - 1] != undefined
                && steps[steps.length - 1].omegastage != undefined) {
                    stage = steps[steps.length - 1].omegastage
                }
            }
        })

        // if(target == undefined) return
        // const previousAffiliation = target.affiliation
        // target = Stage.findUnitByPosition(stage, position)
        // const newAffiliation = target.affiliation
        //
        // if(previousAffiliation != stage.player.affiliation
        // && newAffiliation == stage.player.affiliation) {
        //     // if we converted them from this scripts, cancel the attack!
        //     // someday, add a more verbose way to purposefully cancel an attack from a before attacking script
        //     return steps
        // }

        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        steps.push(step)

        // TODO: Unclear why we are re-checking canTarget - isn't that
        // checked long before the calculateStep is ever called??
        // oh, i figured it out - it is for when a before-attacking script changes the state to allow the character to flip
        if(this.canTarget({performerKey, stage, position}) != true) return steps

        performer = step.omegastage.units[performerKey]
        target = Stage.findUnitByPosition(step.omegastage, position)
        if(target == undefined) return steps

        /////////////
        // DAMAGE //
        ///////////

        // const range = (this.range && this.range.max) || (performer.equippedItem?.attackrange && performer.equippedItem?.attackrange?.max) || (performer.attackrange && performer.attackrange.max) || 1
        let hitmark = 200 // + ((distance - 1) * 50)
        let startingHealth = target.health
        let totalDamage = 0
        const performerName = performer.name || (performer.affiliation == "bad" ? "An enemy" : "???")
        const targetName = target.name || (target.affiliation == "bad" ? "An enemy" : "???")
        let innatePower = Unit.power({"stage": stage, "unit": performer})
        let damage = innatePower

        if(target.effects?.wounded != undefined) {
            damage += target.effects.wounded.power
        }

        if(performer.properties?.includes("counter") || performer.equippedItem?.properties?.includes("counter")) {
            if(performer.affiliation == stage.player.affiliation && stage.turn.number % 2 != 0
            || performer.affiliation != stage.player.affiliation && stage.turn.number % 2 == 0) {
                damage *= 2
            }
        }

        if(performer.properties?.includes("engage") || performer.equippedItem?.properties?.includes("engage")) {
            if(target.health == target.maxhealth) {
                damage *= 2
            }
        }

        const attacktype = performer.equippedItem?.attacktype || performer.attacktype
        if(attacktype == "steel") damage -= target.defense || 0
        if(attacktype == "magic") damage -= target.resistance || 0

        if(target.equippedItem?.weaponType == "shield") {
            const shield = Unit.power({"stage": stage, "unit": target})
            damage -= shield

            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "unperceivedDamage": (target.unperceivedDamage || 0) - shield
                },
            })
        }

        damage = Math.max(0, damage)

        const attackElement = performer.equippedItem?.element || performer.element || performer.attackelement
        const defendElement = target.equippedItem?.element || target.element || target.attack?.element
        let isSuperEffective = false
        let isIneffective = false
        if(performer.properties?.includes("always attacks twice")
        || performer.equippedItem?.properties?.includes("always attacks twice")) {
            isSuperEffective = true
        }
        if(attackElement != undefined) {
            if(Elements[defendElement]?.weaknesses != undefined
            && Elements[defendElement].weaknesses.includes(attackElement)) {
                // We don't need to double the damage or anything, since we'll
                // instead be attacking twice!! Although the second attack
                // might be slightly weaker, given the balance of the game.
                isSuperEffective = true
            }
            if(Elements[defendElement]?.strengths != undefined
            && Elements[defendElement].strengths.includes(attackElement)) {
                // Decrease the damage by a half...
                let damageReduction = damage / 2

                // ...rounded to the nearest 5...
                damageReduction = Math.floor(damageReduction / 5) * 5

                // ...with a minimum of 5.
                damageReduction = Math.max(5, damageReduction)

                damage -= damageReduction
                damage = Math.max(0, damage)
                isIneffective = true
            }
        }

        if(isSuperEffective) {
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": performer.key,
                    "attacktally": (performer.attacktally || 0) + 2,
                },
            })
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "attackedtally": (target.attackedtally || 0) + 2,
                },
            })
        } else {
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": performer.key,
                    "attacktally": (performer.attacktally || 0) + 1,
                },
            })
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "attackedtally": (target.attackedtally || 0) + 1,
                },
            })
        }

        ////////////////
        // ANIMATION //
        //////////////

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))
        Step.add(step, {
            "mark": 180,
            "audio": {"triggerKey": performer.attackaudio ?? "Unit:Attack:Melee"}
        })

        const targetproperties = Unit.properties({"stage": stage, "unit": target})
        if(targetproperties.includes("dodging") || target.equippedItem?.properties?.includes("dodging")) {
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": hitmark / 2,
                "unitKey": target.key,
                "position": target.position,
                "direction": Geometry.multiply(Geometry.perpendicular(direction), 1.5),
            }))
            Step.add(step, PlotFlourishes.TextFloat({
                "mark": hitmark,
                "text": "DODGED",
                "unitKey": target.key,
                "position": {
                    "x": target.position.x,
                    "y": target.position.y + 0.3,
                },
            }))
            Step.add(step, {
                "mark": 180,
                "unit": {
                    "key": target.key,
                    "health": target.health - 0.1
                }
            })
            return steps
        }
        if(performer.properties?.includes("weaken") || performer.equippedItem?.properties?.includes("weaken")) {
            const power = (performer.power || 0) + (performer.equippedItem?.power || 0)
            Step.add(step, {
                "mark": 180,
                "unit": {
                    "key": target.key,
                    "power": (target.power || 0) - power
                }
            })
        }
        if(performer.properties?.includes("poisonous") || performer.equippedItem?.properties?.includes("poisonous")) {
            const power = (performer.power || 0) + (performer.equippedItem?.power || 0) // TODO: use unit.power?
            const existingEffect = target.effects?.poisoned
            Step.add(step, {
                "mark": 180,
                "unit": {
                    "key": target.key,
                    "effects": {
                        "poisoned": {
                            "key": "poisoned",
                            "power": (existingEffect?.power || 0) + power
                        }
                    }
                }
            })
        }
        if(performer.properties?.includes("wounding") || performer.equippedItem?.properties?.includes("wounding")) {
            const power = (performer.power || 0) + (performer.equippedItem?.power || 0) // TODO: use unit.power?
            const existingEffect = target.effects?.wounded
            Step.add(step, {
                "mark": 180,
                "unit": {
                    "key": target.key,
                    "effects": {
                        "wounded": {
                            "key": "wounded",
                            "power": (existingEffect?.power || 0) + power
                        }
                    }
                }
            })
        }
        if(performer.properties?.includes("pinning") || performer.equippedItem?.properties?.includes("pinning")) {
            const power = (performer.power || 0) + (performer.equippedItem?.power || 0) // TODO: use unit.power?
            const existingEffect = target.effects?.pinned
            Step.add(step, {
                "mark": 180,
                "unit": {
                    "key": target.key,
                    "energy": {
                        "move": false,
                    }
                }
            })
            // Step.add(step, {
            //     "mark": 180,
            //     "unit": {
            //         "key": target.key,
            //         "effects": {
            //             "pinned": {
            //                 "key": "pinned",
            //                 "power": (existingEffect?.power || 0) + power
            //             }
            //         }
            //     }
            // })
        }

        let minimumHealth = 0
        if(performer.properties?.includes("non-fatal") || performer.equippedItem?.properties?.includes("non-fatal")) {
            minimumHealth = 10
        }

        if(damage == 0) {
            Step.add(step, {
                "mark": hitmark,
                "audio": {"triggerKey": "Unit:Attack:Nodamage."}
            })
        } else if(damage > 0) {
            totalDamage += damage
            let rollingDamage = damage
            if(target.armor > 0) {
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": target.key,
                        "armor": Math.max(0, target.armor - rollingDamage)
                    },
                })
                rollingDamage -= target.armor
                rollingDamage = Math.max(0, rollingDamage)
            }
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "health": Math.max(minimumHealth, target.health - rollingDamage),
                },
            })
            // Step.add(step, {
            //     "mark": hitmark,
            //     "events": [
            //         {"report": performerName + " attacked for " + (damage / 10) + " damage."}
            //     ]
            // })

            if(isNotPerceivedByAI) {
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": target.key,
                        "unperceivedDamage": (target.unperceivedDamage || 0) + damage
                    },
                })
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": performer.key,
                        "health": performer.health - 0.1
                    },
                })
            }

            if(performer.properties?.includes("pain") || performer.equippedItem?.properties?.includes("pain")) {
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": performer.key,
                        "health": performer.health - Math.floor(damage / 2)
                    },
                })
                let printedDamage = Math.floor(damage / 2) * -1 + "hp" // EMBER
                // let printedDamage = damage / 10 // DICE! divided by 10
                // if(printedDamage == 0.5) printedDamage = "½"
                // // if(printedDamage != 0) printedDamage = "-" + printedDamage
                // printedDamage = "-" + printedDamage + "hp"
                Step.add(step, PlotFlourishes.TextFloat({
                    "mark": hitmark,
                    "type": "damage",
                    "unitKey": performer.key,
                    "position": performer.position,
                    "text": printedDamage
                }))
            }

            if(isSuperEffective != true
            && performer?.properties?.includes("looting")) {
                if(target.health <= 0) {
                    // TODO: Add modal to inform about the new weapon
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": performer.key,
                            "element": defendElement,
                            "weaponImageKey": target.weaponImageKey,
                            "attacktype": target.attacktype,
                            "attackrange": target.attackrange,
                            "power": target.power,
                        }
                    })
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": target.key,
                            "element": "undefined",
                            "weaponImageKey": "",
                            "attacktype": "none",
                            "attackrange": 1,
                            "power": 10,
                        }
                    })
                }
            }

            if(isSuperEffective != true
            && (performer.properties?.includes("forceful") || performer.equippedItem?.properties?.includes("forceful"))) {
                const direction = Geometry.direction(position, performer.position)
                const vector = Geometry.vector(position, performer.position)

                const previousPosition = position
                const nextPosition = Geometry.add(position, vector)

                const collision = Stage.findCollision({
                    stage, previousPosition, nextPosition,
                })

                if(collision == undefined) {
                    Step.add(step, PlotFlourishes.PushedMovement({
                        "mark": hitmark,
                        "unitKey": target.key,
                        "startPosition": previousPosition,
                        "endPosition": nextPosition,
                    }))
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": target.key,
                            "position": nextPosition,
                        }
                    })
                } else if(collision != undefined) {
                    Step.add(step, PlotFlourishes.NudgedMovement({
                        "mark": hitmark,
                        "unitKey": target.key,
                        "position": previousPosition,
                        "direction": direction,
                    }))

                    const damage = 10
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": target.key,
                            "health": target.health - damage
                        },
                    })
                    Step.add(step, PlotFlourishes.TextFloat({
                        "mark": hitmark,
                        "unitKey": target.key,
                        "position": Geometry.add(target.position, {"x": 0.25, "y": 0.25}),
                        "text": "-10hp",
                    }))
                    if(isNotPerceivedByAI) {
                        Step.add(step, {
                            "mark": hitmark,
                            "unit": {
                                "key": target.key,
                                "unperceivedDamage": (target.unperceivedDamage || 0) + damage
                            },
                        })
                    }

                    if(collision.unit != undefined) {
                        Step.add(step, {
                            "mark": hitmark,
                            "unit": {
                                "key": collision.unit.key,
                                "health": collision.unit.health - damage
                            },
                        })
                        Step.add(step, PlotFlourishes.TextFloat({
                            "mark": hitmark,
                            "unitKey": collision.unit.key,
                            "position": Geometry.add(collision.unit.position, {"x": 0.5, "y": 0.5}),
                            "text": "-10hp",
                        }))
                        if(isNotPerceivedByAI) {
                            Step.add(step, {
                                "mark": hitmark,
                                "unit": {
                                    "key": collision.unit.key,
                                    "unperceivedDamage": (collision.unit.unperceivedDamage || 0) + damage
                                },
                            })
                        }
                    }
                }
            } else if(isSuperEffective != true && (performer.properties?.includes("pullback") || performer.equippedItem?.properties?.includes("pullback"))) {
                const direction = Geometry.direction(position, performer.position)
                const oppositeDirection = Geometry.flip(direction)

                const previousPosition = performer.position
                const nextPosition = Geometry.add(performer.position, oppositeDirection)

                const previousTargetPosition = target.position
                const nextTargetPosition = Geometry.add(target.position, oppositeDirection)

                const collision = Stage.findCollision({
                    "stage": stage,
                    previousPosition,
                    nextPosition,
                })

                if(collision == undefined) {
                    Step.add(step, PlotFlourishes.PushedMovement({
                        "mark": hitmark,
                        "unitKey": performer.key,
                        "startPosition": previousPosition,
                        "endPosition": nextPosition,
                    }))
                    Step.add(step, PlotFlourishes.PushedMovement({
                        "mark": hitmark,
                        "unitKey": target.key,
                        "startPosition": previousTargetPosition,
                        "endPosition": nextTargetPosition,
                    }))
                    // Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Pull"}})
                } else if(collision != undefined) {
                    Step.add(step, PlotFlourishes.NudgedMovement({
                        "mark": hitmark,
                        "unitKey": performer.key,
                        "position": performer.position,
                        "direction": direction,
                    }))
                    Step.add(step, PlotFlourishes.NudgedMovement({
                        "mark": hitmark,
                        "unitKey": target.key,
                        "position": target.position,
                        "direction": direction,
                    }))
                    // Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
                }
            } else {
                Step.add(step, PlotFlourishes.NudgedMovement({
                    "mark": hitmark,
                    "unitKey": target.key,
                    "position": position,
                    "direction": direction,
                }))
            }

            Step.add(step, {
                "mark": hitmark,
                "audio": {"triggerKey": target.health < 0 ? "Unit:Attack:FinalHit" : "Unit:Attack:Hit"}
            })
            Step.add(step, {"mark": hitmark, "audio": {"triggerKey": performer.equippedItem?.weaponAudioKey || performer.weaponAudioKey}})

            if(performer.properties != undefined
            && performer.properties.includes("lifesteal")) {
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": performer.key,
                        "health": Math.min(performer.maxhealth, Math.max(minimumHealth, performer.health + 5)),
                    },
                })
                Step.add(step, PlotFlourishes.TextFloat({
                    "mark": hitmark,
                    "type": "healing",
                    "unitKey": performer.key,
                    "position": performer.position,
                    "text": "+5hp",
                }))
            }
        }
        let printedDamage = damage * -1 + "hp" // EMBER
        // let printedDamage = damage / 10 // DICE! divided by 10
        // if(printedDamage == 0.5) printedDamage = "½"
        // printedDamage = "-" + printedDamage + "hp"
        // if(startingHealth <= 10 && (performer.properties?.includes("non-fatal") || performer.equippedItem?.properties?.includes("non-fatal"))) {
        //     printedDamage = "0hp"
        // }
        Step.add(step, PlotFlourishes.TextFloat({
            "mark": hitmark,
            "type": "damage",
            "unitKey": target.key,
            "position": target.position,
            "text": printedDamage
            // "text": Math.round((damage > 0 ? "-" : "") + (damage / 10)) + "hp", // bOOK, dividing by 10
        }))

        if(isSuperEffective) {
            // damage -= Math.ceil(damage * (1 / 2)) // DICE
            hitmark += 200 // total length of the first hit
            hitmark += 50 // to add a short pause between the attacks
            startingHealth = target.health

            Step.add(step, PlotFlourishes.SwingBackMovement({
                "mark": hitmark - 133,
                "unitKey": performer.key,
                "position": performer.position,
                "direction": direction,
            }))
            Step.add(step, {
                "mark": hitmark + 180,
                "audio": {"triggerKey": performer.attackaudio ?? "Unit:Attack:Melee"}
            })
            // Step.add(step, {
            //     "mark": hitmark + 180,
            //     "audio": {"triggerKey": "Unit:Attack:" + (performer.equippedItem?.element || performer.element)}
            // })

            if(damage == 0) {
                Step.add(step, {
                    "mark": hitmark,
                    "audio": {"triggerKey": "Unit:Attack:Nodamage."}
                })
            }
            // ARMOR
            if(damage > 0) {
                let rollingDamage = damage
                totalDamage += damage
                if(target.armor > 0) {
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": target.key,
                            "armor": Math.max(0, target.armor - rollingDamage)
                        },
                    })
                    rollingDamage -= target.armor
                    rollingDamage = Math.max(0, rollingDamage)
                }
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": target.key,
                        "health": Math.max(minimumHealth, target.health - rollingDamage),
                    },
                })
                // Step.add(step, {
                //     "mark": hitmark,
                //     "events": [
                //         {"report": performerName + " attacked again for " + (damage / 10) + " damage."}
                //     ]
                // })

                if(isNotPerceivedByAI) {
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": target.key,
                            "unperceivedDamage": (target.unperceivedDamage || 0) + damage
                        },
                    })
                }

                if(performer.properties?.includes("pain") || performer.equippedItem?.properties?.includes("pain")) {
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": performer.key,
                            "health": performer.health - Math.floor(damage / 2)
                        },
                    })
                    let printedDamage = Math.floor(damage / 2) * -1 + "hp" // EMBER
                    // let printedDamage = damage / 10 // DICE! divided by 10
                    // if(printedDamage == 0.5) printedDamage = "½"
                    // printedDamage = "-" + printedDamage + "hp"
                    Step.add(step, PlotFlourishes.TextFloat({
                        "mark": hitmark,
                        "type": "damage",
                        "unitKey": performer.key,
                        "position": performer.position,
                        "text": printedDamage
                    }))
                }

                if(performer?.properties?.includes("looting")) {
                    if(target.health <= 0) {
                        // TODO: Add modal to inform about the new weapon
                        Step.add(step, {
                            "mark": hitmark,
                            "unit": {
                                "key": performer.key,
                                "element": defendElement,
                                "weaponImageKey": target.weaponImageKey,
                                "attacktype": target.attacktype,
                                "attackrange": target.attackrange,
                                "power": target.power,
                            }
                        })
                        Step.add(step, {
                            "mark": hitmark,
                            "unit": {
                                "key": target.key,
                                "element": "undefined",
                                "weaponImageKey": "none",
                                "attacktype": "none",
                                "attackrange": 1,
                                "power": 10,
                            }
                        })
                    }
                }

                if(performer.properties?.includes("forceful") || performer.equippedItem?.properties?.includes("forceful")) {
                    const direction = Geometry.direction(position, performer.position)
                    const vector = Geometry.vector(position, performer.position)

                    const previousPosition = position
                    const nextPosition = Geometry.add(position, vector)

                    const collision = Stage.findCollision({
                        stage, previousPosition, nextPosition,
                    })

                    if(collision == undefined) {
                        Step.add(step, PlotFlourishes.PushedMovement({
                            "mark": hitmark,
                            "unitKey": target.key,
                            "startPosition": previousPosition,
                            "endPosition": nextPosition,
                        }))
                        Step.add(step, {
                            "mark": hitmark,
                            "unit": {
                                "key": target.key,
                                "position": nextPosition,
                            }
                        })
                    } else if(collision != undefined) {
                        Step.add(step, PlotFlourishes.NudgedMovement({
                            "mark": hitmark,
                            "unitKey": target.key,
                            "position": target.position,
                            "direction": direction,
                        }))

                        const damage = 10
                        Step.add(step, {
                            "mark": hitmark,
                            "unit": {
                                "key": target.key,
                                "health": target.health - damage
                            },
                        })
                        Step.add(step, PlotFlourishes.TextFloat({
                            "mark": hitmark,
                            "unitKey": target.key,
                            "position": Geometry.add(target.position, {"x": 0.25, "y": 0.25}),
                            "text": "-10hp",
                        }))
                        if(isNotPerceivedByAI) {
                            Step.add(step, {
                                "mark": hitmark,
                                "unit": {
                                    "key": target.key,
                                    "unperceivedDamage": (target.unperceivedDamage || 0) + damage
                                },
                            })
                        }

                        if(collision.unit != undefined) {
                            Step.add(step, {
                                "mark": hitmark,
                                "unit": {
                                    "key": collision.unit.key,
                                    "health": collision.unit.health - damage
                                },
                            })
                            Step.add(step, PlotFlourishes.TextFloat({
                                "mark": hitmark,
                                "unitKey": collision.unit.key,
                                "position": Geometry.add(collision.unit.position, {"x": 0.5, "y": 0.5}),
                                "text": "-10hp",
                            }))
                            if(isNotPerceivedByAI) {
                                Step.add(step, {
                                    "mark": hitmark,
                                    "unit": {
                                        "key": collision.unit.key,
                                        "unperceivedDamage": (collision.unit.unperceivedDamage || 0) + damage
                                    },
                                })
                            }
                        }
                    }
                } else if(performer.properties?.includes("pullback") || performer.equippedItem?.properties?.includes("pullback")) {
                    const direction = Geometry.direction(position, performer.position)
                    const oppositeDirection = Geometry.flip(direction)

                    const previousPosition = performer.position
                    const nextPosition = Geometry.add(performer.position, oppositeDirection)

                    const previousTargetPosition = target.position
                    const nextTargetPosition = Geometry.add(target.position, oppositeDirection)

                    const collision = Stage.findCollision({
                        "stage": stage,
                        previousPosition,
                        nextPosition,
                    })

                    if(collision == undefined) {
                        Step.add(step, PlotFlourishes.PushedMovement({
                            "mark": hitmark,
                            "unitKey": performer.key,
                            "startPosition": previousPosition,
                            "endPosition": nextPosition,
                        }))
                        Step.add(step, PlotFlourishes.PushedMovement({
                            "mark": hitmark,
                            "unitKey": target.key,
                            "startPosition": previousTargetPosition,
                            "endPosition": nextTargetPosition,
                        }))
                        // Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Pull"}})
                    } else if(collision != undefined) {
                        Step.add(step, PlotFlourishes.NudgedMovement({
                            "mark": hitmark,
                            "unitKey": performer.key,
                            "position": performer.position,
                            "direction": direction,
                        }))
                        Step.add(step, PlotFlourishes.NudgedMovement({
                            "mark": hitmark,
                            "unitKey": target.key,
                            "position": target.position,
                            "direction": direction,
                        }))
                        // Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
                    }
                } else {
                    Step.add(step, PlotFlourishes.NudgedMovement({
                        "mark": hitmark,
                        "unitKey": target.key,
                        "position": target.position,
                        "direction": direction,
                    }))
                }

                // Step.add(step, PlotFlourishes.NudgedMovement({
                //     "mark": hitmark,
                //     "unitKey": target.key,
                //     "position": target.position,
                //     "direction": direction,
                // }))
                Step.add(step, {
                    "mark": hitmark,
                    "audio": {"triggerKey": target.health < 0 ? "Unit:Attack:FinalHit" : "Unit:Attack:Hit"}
                })
                Step.add(step, {
                    "mark": hitmark,
                    "audio": {"triggerKey": performer.equippedItem?.weaponAudioKey || performer.weaponAudioKey}
                })

                if(performer.properties != undefined
                && performer.properties.includes("lifesteal")) {
                    Step.add(step, {
                        "mark": hitmark,
                        "unit": {
                            "key": performer.key,
                            "health": Math.min(performer.maxhealth, Math.max(minimumHealth, performer.health + 10)),
                        },
                    })
                    Step.add(step, PlotFlourishes.TextFloat({
                        "mark": hitmark,
                        "type": "healing",
                        "unitKey": performer.key,
                        "position": performer.position,
                        "text": "+5hp",
                    }))
                }
            }
            let printedDamage = damage * -1 + "hp" // EMBER
            // let printedDamage = damage / 10 // DICE! divided by 10
            // if(printedDamage == 0.5) printedDamage = "½"
            // printedDamage = "-" + printedDamage + "hp"
            // if(startingHealth <= 10 && (performer.properties?.includes("non-fatal") || performer.equippedItem?.properties?.includes("non-fatal"))) {
            //     printedDamage = "0hp"
            // }
            Step.add(step, PlotFlourishes.TextFloat({
                "mark": hitmark,
                "type": "damage",
                "unitKey": target.key,
                "position": target.position,
                "text": printedDamage
            }))
            // Step.add(step, PlotFlourishes.TextFloat({
            //     "mark": hitmark,
            //     // "type": "damage",
            //     "unitKey": target.key,
            //     "position": {
            //         "x": target.position.x,
            //         "y": target.position.y + 0.3,
            //     },
            //     "scale": 0.5,
            //     "rotate": 12,
            //     "text": "effective!!",
            // })) // DICE removed the super effective label
            // Step.add(step, PlotFlourishes.TextFloat({
            //     "mark": hitmark,
            //     // "type": "damage",
            //     "unitKey": target.key,
            //     "position": {
            //         "x": target.position.x,
            //         "y": target.position.y + 0.6,
            //     },
            //     "text": "EFFECTIVE",
            // }))
        }

        // if(isIneffective) {
        //     Step.add(step, PlotFlourishes.TextFloat({
        //         "mark": hitmark,
        //         // "type": "damage",
        //         "unitKey": target.key,
        //         "position": {
        //             "x": target.position.x,
        //             "y": target.position.y + 0.3,
        //         },
        //         "scale": 0.5,
        //         "text": "ineffective",
        //     }))
        // }

        if(target.health > 0
        && (performer.properties?.includes("attack-then-heal")
        || performer.equippedItem?.properties?.includes("attack-then-heal"))) {
            hitmark += 200
            hitmark += 300 // a longer gap

            Step.add(step, PlotFlourishes.Shudder({
                "mark": hitmark,
                "unitKey": target.key,
                "position": target.position,
                "intensity": 0.05,
            }))

            let healing = innatePower
            if(performer.properties?.includes("stronger-healing")
            || performer.equippedItem?.properties?.includes("stronger-healing")) {
                healing *= 2
            }

            if(performer.affiliation != target.affiliation
            && (performer.properties?.includes("harm-rather-than-heal")
            || performer.equippedItem?.properties?.includes("harm-rather-than-heal"))) {
                Step.add(step, {
                    "mark": hitmark + 400 + 200,
                    "unit": {
                        "key": target.key,
                        "health": Math.max(0, target.health - healing)
                    },
                })
                const DIVISOR = 1
                // const DIVISOR = 10 // EMBER
                Step.add(step, PlotFlourishes.TextFloat({
                    "mark": hitmark + 400 + 200,
                    "unitKey": target.key,
                    "position": target.position,
                    "text": "-" + (healing / DIVISOR) + "hp"
                }))

                if(performer.properties?.includes("inflict-regenerate")
                || performer.equippedItem?.properties?.includes("inflict-regenerate")) {
                    const existingEffect = target.effects?.poisoned
                    Step.add(step, {
                        "mark": hitmark + 400 + 200,
                        "unit": {
                            "key": target.key,
                            "effects": {
                                "poisoned": {
                                    "key": "poisoned",
                                    "power": (existingEffect?.power || 0) + healing
                                }
                            }
                        }
                    })
                }
            } else {
                Step.add(step, {
                    "mark": hitmark + 400 + 200,
                    "unit": {
                        "key": target.key,
                        "health": Math.min(target.maxhealth, target.health + healing)
                    },
                })
                const DIVISOR = 1 // EMBER
                // const DIVISOR = 10
                Step.add(step, PlotFlourishes.TextFloat({
                    "mark": hitmark + 400 + 200,
                    "type": "healing",
                    "unitKey": target.key,
                    "position": target.position,
                    "text": "+" + (healing / DIVISOR) + "hp",
                    "value": healing,
                }))

                if(performer.properties?.includes("inflict-regenerate")
                || performer.equippedItem?.properties?.includes("inflict-regenerate")) {
                    const existingEffect = target.effects?.regenerate
                    Step.add(step, {
                        "mark": hitmark + 400 + 200,
                        "unit": {
                            "key": target.key,
                            "effects": {
                                "regenerate": {
                                    "key": "regenerate",
                                    "power": (existingEffect?.power || 0) + healing
                                }
                            }
                        }
                    })
                }
                if(performer.properties?.includes("heal-then-refresh")
                || performer.equippedItem?.properties?.includes("heal-then-refresh")) {
                    Step.add(step, {
                        "mark": hitmark + 400 + 200,
                        "unit": {
                            "key": target.key,
                            "energy": {
                                "move": true,
                                "act": true,
                            }
                        }
                    })
                }
            }
        }

        if(performer.properties?.includes("rampage") || performer.equippedItem?.properties?.includes("rampage")) {
            if(target.health == 0) {
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": performer.key,
                        "effects": {
                            "rampaging": {
                                "key": "rampaging",
                            }
                        }
                    }
                })
            }
        }

        // if(isSuperEffective) {
        //     Step.add(step, {
        //         "mark": hitmark,
        //         "events": [
        //             // {"report": "Supereffective!! " + performerName + " attacked for " + (innatePower / 10) + " damage, but because " + attackElement + " is effective against " + defendElement + ", " + performerName + " attacked twice for " + totalDamage + " damage.", "isFinisher": true}
        //             {"report": "Supereffective!! " + performerName + " attacked for " + (totalDamage / 10) + " damage.", "isFinisher": true}
        //         ]
        //     })
        // } else if(isIneffective) {
        //     Step.add(step, {
        //         "mark": hitmark,
        //         "events": [
        //             // {"report": "Ineffective... " + performerName + " attacked for " + (innatePower / 10) + " damage, but " + attackElement + " is ineffective against " + defendElement + ", it only dealt " + totalDamage + " damage.", "isFinisher": true}
        //             {"report": "Ineffective... " + performerName + " attacked for " + (totalDamage / 10) + " damage.", "isFinisher": true}
        //         ]
        //     })
        // } else {
        Step.add(step, {
            "mark": hitmark,
            "events": [
                {
                    "isFinisher": true,
                    "report": () => {
                        return (
                            <span>{performerName} attacked for <Underlined><Power>{totalDamage}</Power> damage</Underlined>.</span>
                        )
                    },
                }
            ]
        })

        ////////////////////
        // STATE CHANGES //
        //////////////////

        Step.add(step, {
            "mark": hitmark,
            "unit": {
                "key": target.key,
                "state": "aggroed",
            }
        })
        Step.add(step, {
            "mark": 0,
            "unit": {
                "key": performer.key,
                "hasAttacked": true,
                "state": "aggroed",
            }
        })
        Step.add(step, {
            "mark": hitmark,
            "unit": {
                "key": performer.key,
                "flags": {
                    ["hasAttacked:" + target.key]: true,
                    "attackElement": attackElement,
                }
            }
        })

        // const encounter = Object.values(stage.world.encounters).find((zone) => {
        //     return Geometry.isInBounds(zone, target.position)
        // })
        // Object.values(stage.units).forEach((unit) => {
        //     if(unit.affiliation == "bad"
        //     && Geometry.isInBounds(encounter, unit.position)) {
        //         Step.add(step, {
        //             "mark": hitmark,
        //             "unit": {
        //                 "key": unit.key,
        //                 "state": "aggroed",
        //             }
        //         })
        //     }
        // })

        if(performer.key == "swashbuckler" && target.role == "barrel") {
            Step.add(step, {"mark": hitmark, ...Step.deltaflag("swashbuckler has attacked a barrel", true)})
        }

        if(performer.affiliation == stage.player.affiliation) {
            if(stage.flags["tutorial:hasAttacked"] != true) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttacked", true)})
            }
            if(isIneffective == true
            && stage.flags["tutorial:hasAttackedIneffectively"] != true) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedIneffectively", true)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:IneffectiveAttackerElement", attackElement)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:IneffectiveAttackedElement", defendElement)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:latestAttackEffectivity", "isIneffective")})
            }
            if(isSuperEffective == true
            && stage.flags["tutorial:hasAttackedSuperEffectively"] != true) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedSuperEffectively", true)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:SuperEffectiveAttackerElement", attackElement)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:SuperEffectiveAttackedElement", defendElement)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:latestAttackEffectivity", "isSuperEffective")})
            }
            if((attackElement == "earth" || attackElement == "axe" || attackElement == "gun")
            && (defendElement == "water" || defendElement == "spear" || defendElement == "bow")
            && stage.flags["tutorial:hasAttackedEffectivelyWithEarth"] != true) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedIneffectivelyWithEarth", true)})
            }
            if(target.attackrange != performer.attackrange
            && stage.flags["tutorial:hasAttackedWithoutCounterattack"] != true) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedWithoutCounterattack", true)})
            }
            if(Geometry.distance(performer.position, target.position) > 1
            && target.health > 0
            && stage.flags["tutorial:hasAttackedAtRange"] != true) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedAtRange", true)})
            }
            if(target.health == 0
            && stage.flags["tutorial:hasKilled"] != true) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasKilled", true)})
            }
            if((attackElement == "earth" || attackElement == "axe" || attackElement == "gun")
            && (defendElement == "earth" || defendElement == "axe" || defendElement == "gun")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedBlueWithBlue", true)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:latestAttackEffectivity", "isNeutral")})
            }
            if((attackElement == "water" || attackElement == "spear" || attackElement == "bow")
            && (defendElement == "water" || defendElement == "spear" || defendElement == "bow")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedGreenWithGreen", true)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:latestAttackEffectivity", "isNeutral")})
            }
            if((attackElement == "fire" || attackElement == "sword" || attackElement == "dagger")
            && (defendElement == "fire" || defendElement == "sword" || defendElement == "dagger")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasAttackedRedWithRed", true)})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:latestAttackEffectivity", "isNeutral")})
            }
            if((attackElement == "earth" || attackElement == "axe" || attackElement == "gun")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackerColor", "green")})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackerElement", "earth")})
            }
            if((attackElement == "water" || attackElement == "spear" || attackElement == "bow")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackerColor", "blue")})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackerElement", "water")})
            }
            if((attackElement == "fire" || attackElement == "sword" || attackElement == "dagger")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackerColor", "red")})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackerElement", "fire")})
            }
            if((defendElement == "earth" || defendElement == "axe" || defendElement == "gun")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackedColor", "green")})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackedElement", "earth")})
            }
            if((defendElement == "water" || defendElement == "spear" || defendElement == "bow")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackedColor", "blue")})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackedElement", "water")})
            }
            if((defendElement == "fire" || defendElement == "sword" || defendElement == "dagger")) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackedColor", "red")})
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:AttackedElement", "fire")})
            }

        } else {
            Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasBeenAttacked", true)})
            if(stage.turn.number % 2 == 0) {
                Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasBeenAttackedInCounterattack", true)})
            }
        }

        // Post-Attack Dialogue //

        if(performer.canBetray == true
        && performer?.properties?.includes("no betrayals") != true) {
            if(performer.affiliation == stage.player.affiliation
            && target.affiliation == stage.player.affiliation) {
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": target.key,
                        // "affiliation": target.affiliation != target.preferredAffiliation ? target.preferredAffiliation : stage.player.betrayedAffiliation,
                        "affiliation": target.betrayedAffiliation,
                        // "bodyKey": "neutral",
                    }
                })
                if(target.scripts != undefined
                && target.scripts["betrayed"] != undefined
                && target.health > 0) {
                    steps.push(...Stage.processEventSteps(step.omegastage, target.scripts["betrayed"]))
                }
            }
        }

        stage.scripts.forEach((condition) => {
            if(condition.trigger == "attacking"
            && condition.canBeTriggered(stage, performer, target) == true) {
                const conditionEvents = condition.events
                conditionEvents.unshift({
                    "omegastage": stage,
                    "name": "SavestateCapture",
                    "savestateSlug": condition.title || "Condition_" + stage.scripts.indexOf(condition),
                })
                steps.push(...Stage.processEventSteps(step.omegastage, conditionEvents))
            }
        })

        return steps
    }
}

skills["heal"] = {
    "key": "heal",
    "name": "Heal",
    "role": "support",

    "iconKey": "hearts",
    "description": "Restore 2 Health.", // TODO: make this dynamic.
    "color": "#FF5C3A", // "#FE6D44",

    "type": "invoke",
    "range": null,

    // // "power": 15,
    // "power": 20, // DICE!! NOT SCALING WITH INNATE EQUIPMENT POWER!!!
    // "power": 15,
    "power": 20, // BOOK

    "getPriority": getSupportPriority,
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.type == "thing") return false
        if(target.key == performer.key) return false
        if(target.affiliation != performer.affiliation
        && target.properties?.includes("can be pacified") == false) {
            return false
        }
        return true
    },

    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const steps = []

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const hitmark = 0

        // if(target.maxhealth != target.health
        // && performer.scripts["help"] != undefined) {
        //     steps.push(...Stage.processEventSteps(stage, performer.scripts["help"]))
        // }

        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        steps.push(step)

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        Step.add(step, PlotFlourishes.NudgedMovement({
            "mark": hitmark,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))
        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Heal"}})


        let healing = 20
        if(performer?.properties?.includes("scaled-healing") || performer?.equippedItem?.properties?.includes("scaled-healing")) {
            healing = (performer.power || 0) + (performer.equippedItem?.power || 0)
        }
        // if(target.health + healing > target.maxhealth) {
        //     healing = target.maxhealth - target.health
        // }

        if(target.properties?.includes("can be pacified")) {
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "state": "pacified",
                }
            })
        }

        Step.add(step, {
            "mark": hitmark,
            "unit": {
                "key": target.key,
                "health": Math.min(target.maxhealth, target.health + healing)
            },
        })

        if(performer.properties != undefined
        && performer.properties.includes("mutually-healing")) {
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": performer.key,
                    "health": Math.min(performer.maxhealth, performer.health + healing)
                },
            })
        }

        if(target.effects.burning != undefined) {
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "effects": {
                        "burning": undefined,
                    }
                },
            })
        }

        Step.add(step, PlotFlourishes.NudgedMovement({
            "mark": hitmark,
            "unitKey": target.key,
            "position": target.position,
            "direction": Geometry.flip(direction),
        }))
        const DIVISOR = 1 // EMBER
        // const DIVISOR = 10
        Step.add(step, PlotFlourishes.TextFloat({
            "mark": hitmark,
            "type": "healing",
            "unitKey": target.key,
            "position": target.position,
            // "text": "+" + (healing / 10) // DICE
            "text": "+" + (healing / DIVISOR) + "hp"
        }))

        Step.add(step, {"mark": hitmark, ...Step.deltaflag("tutorial:hasHealed", true)})

        if(target.maxhealth != target.health
        && performer.scripts != undefined
        && performer.scripts["help"] != undefined) {
            steps.push(...Stage.processEventSteps(step.omegastage, performer.scripts["help"]))

            // ..
        }

        return steps
    }
}

skills["defend"] = {
    "key": "defend",
    "name": "Defend",
    "role": "support",

    "type": "invoke",
    "range": null,

    "description": "Grants temporary armor until your next turn.",
    "iconKey": "armor-upgrade",

    // "isRenderedEvenIfCanNotTarget": true,
    // "getPriority": function getSupportPriority({performerKey, stage, position}) {
    //     const performer = stage.units[performerKey]
    //     const target = Stage.findUnitByPosition(stage, position)
    //     if(target == undefined) return 0.1
    //     return 1
    // },
    "getPriority": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return 0.1
        return 5.1
    },
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        // if(target.affiliation != performer.affiliation) return false
        return true
    },

    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const steps = []

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const hitmark = 0

        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        steps.push(step)

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        if(performer.key != target.key) {
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 0,
                "unitKey": performer.key,
                "position": performer.position,
                "direction": direction,
            }))
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 0,
                "unitKey": target.key,
                "position": target.position,
                "direction": Geometry.flip(direction),
            }))
        } else {
            // Step.add(step, PlotFlourishes.JumpMovement({
            //     "mark": hitmark,
            //     "unitKey": performer.key,
            //     "startPosition": performer.position,
            //     "endPosition": performer.position,
            // }))
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 0,
                "unitKey": performer.key,
                "position": performer.position,
                "direction": {"y": 1},
            }))
        }

        Step.add(step, {
            "mark": 0,
            "audio": {"triggerKey": "Unit:Heal"}
        })

        let armor = (performer.equippedItem.power || 0) + (performer.power || 0)

        Step.add(step, {
            "mark": 100,
            "unit": {
                "key": target.key,
                "armor": (target.armor || 0) + armor
            },
        })
        const DIVISOR = 1
        Step.add(step, PlotFlourishes.TextFloat({
            "mark": 100,
            "type": "armor",
            "unitKey": target.key,
            "position": target.position,
            "text": "+" + (armor / DIVISOR) + "■" // DICE
        }))

        return steps
    }
}

skills["dash"] = {
    "key": "dash",
    "name": "Dash",
    "role": "support",

    "type": "invoke",
    "range": 0,

    "getPriority": function() {
        return 1
    },
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        return performer.energy["move"] == false
    },

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        // const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": {"x": -1},
        }))

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        Step.add(step, {
            "mark": 200,
            "unit": {
                "key": performer.key,
                "energy": {"move": true},
            }
        })

        return step
    }
}

skills["rally"] = {
    "key": "rally",
    "name": "Refresh",
    "role": "support",

    "description": "Shanty: Sing a song to an ally, refreshing their action and movement for the turn.",

    "type": "invoke",
    "range": 1,

    "isRenderedEvenIfCanNotTarget": true,  // EMBER

    "getPriority": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return 0.1
        if(target != undefined
        && target.affiliation == performer.affiliation) {
            return 5.1
        } else {
            return 4
        }
    },
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.affiliation != performer.affiliation) return false
        // if(target.energy["act"] == true && target.energy["move"] == true) return false
        return true
    },

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        const steps = [step]

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return steps

        Step.add(step, {
            "mark": 200,
            "unit": {
                "key": target.key,
                "energy": {"move": true, "act": true},
            }
        })
        Step.add(step, PlotFlourishes.NudgedMovement({
            "mark": 200,
            "unitKey": target.key,
            "position": target.position,
            "direction": direction,
        }))
        if(stage.flags["tutorial:hasRallied"] != true) {
            Step.add(step, {"mark": 200, ...Step.deltaflag("tutorial:hasRallied", true)})
        }
        if(performer.properties?.includes("dice/speedup") || performer.equippedItem?.properties?.includes("dice/speedup")) {
            Step.add(step, {
                "mark": 200,
                "unit": {
                    "key": target.key,
                    "moverange": 3,
                }
            })
        }
        // if(performer.properties?.includes("buff-rally")) {
        //     const power = performer.power ?? performer.equippedItem?.power
        //     Step.add(step, {
        //         "mark": 200,
        //         "unit": {
        //             "key": target.key,
        //             "power": (target.power || 0) + (power)
        //         }
        //     })
        // }

        stage.scripts.forEach((condition) => {
            if(condition.trigger == "supporting"
            && condition.canBeTriggered(stage, performer, target) == true) {
                steps.push(...Stage.processEventSteps(step.omegastage, condition.events))
            }
        })

        return steps
    }
}

skills["stun"] = {
    "key": "Stun",
    "name": "Stun",
    "role": "support",

    // "description": "Shanty: Sing a song to an ally, refreshing their action and movement for the turn.",

    "type": "invoke",
    "range": 1,

    "getPriority": getSupportPriority,
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.affiliation != performer.affiliation) return false
        // if(target.energy["invoke skill"] == true && target.energy["move"] == true) return false
        return true
    },

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        const steps = [step]

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return steps

        Step.add(step, {
            "mark": 200,
            "unit": {
                "key": target.key,
                "energy": {"move": true, "invoke skill": true},
            }
        })
        Step.add(step, PlotFlourishes.NudgedMovement({
            "mark": 200,
            "unitKey": target.key,
            "position": target.position,
            "direction": direction,
        }))
        if(stage.flags["tutorial:hasRallied"] != true) {
            Step.add(step, {"mark": 200, ...Step.deltaflag("tutorial:hasRallied", true)})
        }

        stage.scripts.forEach((condition) => {
            if(condition.trigger == "supporting"
            && condition.canBeTriggered(stage, performer, target) == true) {
                steps.push(...Stage.processEventSteps(step.omegastage, condition.events))
            }
        })

        return steps
    }
}

skills["strengthen"] = {
    "key": "strengthen",
    "name": "Strengthen",
    "role": "support",

    "type": "invoke",
    "range": 1,

    "getPriority": getSupportPriority,
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.affiliation != performer.affiliation) return false
        return true
    },

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        const steps = [step]

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return steps

        Step.add(step, PlotFlourishes.NudgedMovement({
            "mark": 200,
            "unitKey": target.key,
            "position": target.position,
            "direction": direction,
        }))
        const power = Unit.power({"stage": stage, "unit": performer})
        Step.add(step, {
            "mark": 200,
            "unit": {
                "key": target.key,
                "power": (target.power || 0) + (power)
            }
        })

        // stage.scripts.forEach((condition) => {
        //     if(condition.trigger == "supporting"
        //     && condition.canBeTriggered(stage, performer, target) == true) {
        //         steps.push(...Stage.processEventSteps(step.omegastage, condition.events))
        //     }
        // })

        return steps
    }
}

skills["weaken"] = {
    "key": "weaken",
    "name": "Weaken",
    "role": "attack",

    "type": "invoke",
    "range": 1,

    // "getPriority": getSupportPriority,
    "getPriority": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return 0.1
        return 5.1
    },
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.affiliation == performer.affiliation) return false
        return true
    },

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        const steps = [step]

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return steps

        Step.add(step, PlotFlourishes.NudgedMovement({
            "mark": 200,
            "unitKey": target.key,
            "position": target.position,
            "direction": direction,
        }))
        const power = Unit.power({"stage": stage, "unit": performer})
        Step.add(step, {
            "mark": 200,
            "unit": {
                "key": target.key,
                "power": (target.power || 0) - (power)
            }
        })

        stage.scripts.forEach((condition) => {
            if(condition.trigger == "supporting"
            && condition.canBeTriggered(stage, performer, target) == true) {
                steps.push(...Stage.processEventSteps(step.omegastage, condition.events))
            }
        })

        return steps
    }
}

skills["speedup"] = {
    "key": "speedup",
    "name": "Speedup",
    "role": "support",

    "type": "invoke",
    "range": 1,

    "getPriority": getSupportPriority,
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.affiliation != performer.affiliation) return false
        return true
    },

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })
        const steps = [step]

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return steps

        Step.add(step, PlotFlourishes.NudgedMovement({
            "mark": 200,
            "unitKey": target.key,
            "position": target.position,
            "direction": direction,
        }))
        const power = performer.power ?? performer.equippedItem?.power
        Step.add(step, {
            "mark": 200,
            "unit": {
                "key": target.key,
                "moverange": (target.moverange ?? 0) + (power)
            }
        })

        stage.scripts.forEach((condition) => {
            if(condition.trigger == "supporting"
            && condition.canBeTriggered(stage, performer, target) == true) {
                steps.push(...Stage.processEventSteps(step.omegastage, condition.events))
            }
        })

        return steps
    }
}

skills["push"] = {
    "key": "push",
    "name": "Push",
    "role": "reposition",
    // "isRenderedEvenIfCanNotTarget": true, // HEIST

    "iconKey": "hand",
    "description": "Pushes 1 tile.",
    "color": "#FF5C3A", // "#FE6D44",
    "power": 10,

    "type": "invoke",
    "range": 1,

    "canTarget": canTarget,
    "getPriority": getSupportPriority,

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        const vector = Geometry.vector(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        const previousPosition = position
        const nextPosition = Geometry.add(position, vector)

        Step.add(step, {
            "intent": {
                "type": "reposition",
                "positions": [previousPosition, nextPosition]
            },
        })

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        const collision = Stage.findCollision({
            stage, previousPosition, nextPosition,
            // "options": {
            //     "isIgnoringZoneBoundaries": true, // HEIST
            // }
        })

        if(collision == undefined) {
            Step.add(step, PlotFlourishes.PushedMovement({
                "mark": 200,
                "unitKey": target.key,
                "startPosition": previousPosition,
                "endPosition": nextPosition,
            }))
            // Step.add(step, {
            //     "mark": 200,
            //     "unit": {
            //         "key": target.key,
            //         "position": nextPosition,
            //     }
            // })
        } else if(collision != undefined) {
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 200,
                "unitKey": target.key,
                "position": target.position,
                "direction": direction,
            }))

            const damage = 10
            Step.add(step, {
                "mark": 200,
                "unit": {
                    "key": target.key,
                    "health": target.health - damage
                },
            })

            if(collision.unit != undefined) {
                Step.add(step, {
                    "mark": 200,
                    "unit": {
                        "key": collision.unit.key,
                        "health": collision.unit.health - damage
                    },
                })
            }
        }

        return step
    }
}

skills["swap"] = {
    "key": "swap",
    "name": "Swap",
    "role": "reposition",
    // "isRenderedEvenIfCanNotTarget": true, // HEIST

    "description": "Trades positions with a unit",

    "type": "invoke",
    "range": 1,

    "canTarget": canTarget,
    "getPriority": getSupportPriority,

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) {
            Step.add(step, [
                {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}}
            ])
            Step.add(step, PlotFlourishes.SwingBackMovement({
                "mark": 0,
                "unitKey": performer.key,
                "position": performer.position,
                "direction": direction,
            }))
            return step
        }

        Step.add(step, PlotFlourishes.PushedMovement({
            "mark": 0,
            "unitKey": performer.key,
            "startPosition": performer.position,
            "endPosition": target.position,
        }))
        Step.add(step, PlotFlourishes.PushedMovement({
            "mark": 0,
            "unitKey": target.key,
            "startPosition": target.position,
            "endPosition": performer.position,
        }))
        Step.add(step, [
            // {
            //     "mark": 0,
            //     "unit": {
            //         "key": performer.key,
            //         "position": target.position,
            //     }
            // },
            // {
            //     "mark": 0,
            //     "unit": {
            //         "key": target.key,
            //         "position": performer.position,
            //     }
            // },
            {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}}
        ])

        return step
    }
}

skills["pull"] = {
    "key": "pull",
    "name": "Pullback",
    "role": "reposition",
    // "isRenderedEvenIfCanNotTarget": true, // HEIST


    "iconKey": "pointing",
    "description": "Pull you and an ally back 1 tile.",
    "color": "#FF5C3A", // "#FE6D44",
    "power": 10,

    "type": "invoke",
    "range": 1,

    "canTarget": canTarget,
    "getPriority": getSupportPriority,

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        const oppositeDirection = Geometry.flip(direction)

        if(direction.x != 0
        && direction.y != 0) {
            console.log("Cannot calculate pull skill with non-orthogonal direction.")
            return step
        }

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) {
            return step
        }

        const previousPosition = performer.position
        const nextPosition = Geometry.add(performer.position, oppositeDirection)

        const previousTargetPosition = target.position
        const nextTargetPosition = Geometry.add(target.position, oppositeDirection)

        Step.add(step, {
            "intent": {
                "type": "reposition",
                "positions": [previousPosition, nextPosition]
            },
        })
        Step.add(step, {
            "intent": {
                "type": "reposition",
                "positions": [previousTargetPosition, nextTargetPosition]
            },
        })

        const collision = Stage.findCollision({
            "stage": stage,
            previousPosition,
            nextPosition,
        })

        if(collision == undefined) {
            // Step.add(step, {
            //     "mark": 0,
            //     "unit": {
            //         "key": performer.key,
            //         "position": nextPosition,
            //     },
            // })
            Step.add(step, PlotFlourishes.PushedMovement({
                "mark": 0,
                "unitKey": performer.key,
                "startPosition": previousPosition,
                "endPosition": nextPosition,
            }))
            // Step.add(step, {
            //     "mark": 0,
            //     "unit": {
            //         "key": target.key,
            //         "position": nextTargetPosition,
            //     }
            // })
            Step.add(step, PlotFlourishes.PushedMovement({
                "mark": 0,
                "unitKey": target.key,
                "startPosition": previousTargetPosition,
                "endPosition": nextTargetPosition,
            }))
            Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Pull"}})
        } else if(collision != undefined) {
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 0,
                "unitKey": performer.key,
                "position": performer.position,
                "direction": direction,
            }))
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 0,
                "unitKey": target.key,
                "position": target.position,
                "direction": direction,
            }))
            Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        }

        return step
    }
}

skills["suplex"] = {
    "key": "suplex",
    "name": "Flip",
    "role": "reposition",
    // "isRenderedEvenIfCanNotTarget": true, // HEIST

    "iconKey": "grab",
    "description": "Flips a unit to your other side.",
    "power": 20,

    "type": "invoke",
    "range": 1,

    "canTarget": canTarget,
    "getPriority": getSupportPriority,

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({"type": "invoke skill", "alphastage": stage})

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))
        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Pull"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        const previousPosition = performer.position
        const nextPosition = Geometry.add(performer.position, Geometry.flip(direction))

        const collision = Stage.findCollision({
            stage, previousPosition, nextPosition,
        })

        if(collision == undefined) {
            Step.add(step, {
                "mark": 200,
                "unit": {
                    "key": target.key,
                    "position": nextPosition,
                },
                "intent": {
                    "type": "reposition",
                    "positions": [target.position, performer.position, nextPosition]
                },
            })
            Step.add(step, PlotFlourishes.ArcedMovement({
                "mark": 200,
                "endmark": 200 + 150,
                "unitKey": target.key,
                "startPosition": target.position,
                "endPosition": nextPosition,
            }))
        } else {
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 200,
                "unitKey": target.key,
                "position": target.position,
                "direction": direction,
            }))
        }

        return step
    }
}

skills["pivot"] = {
    "key": "pivot",
    "name": "Hop",
    "role": "reposition",
    // "isRenderedEvenIfCanNotTarget": true, // HEIST

    "description": "Hop: Can hop over an ally.",

    "type": "invoke",
    "range": 1,
    "canTarget": canTarget,
    "getPriority": getSupportPriority,

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        const previousPosition = performer.position
        const nextPosition = Geometry.add(target.position, direction)

        const collision = Stage.findCollision({
            stage, previousPosition, nextPosition,
        })

        if(collision == undefined) {
            // Step.add(step, {
            //     "mark": 200,
            //     "unit": {
            //         "key": performer.key,
            //         "position": nextPosition,
            //     },
            //     "intent": {
            //         "type": "reposition",
            //         "positions": [performer.position, target.position, nextPosition]
            //     },
            // })
            Step.add(step, PlotFlourishes.PushedMovement({
                "mark": 200,
                "unitKey": performer.key,
                "startPosition": performer.position,
                "endPosition": nextPosition,
            }))
        } else {
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 200,
                "unitKey": performer.key,
                "position": performer.position,
                "direction": direction,
            }))
        }

        return step
    }
}

skills["smite"] = {
    "key": "smite",
    "name": "Push",
    "role": "reposition",
    // "isRenderedEvenIfCanNotTarget": true, // HEIST

    "description": "Smite: Push an ally two tiles.",
    "color": "#FF5C3A", // "#FE6D44",

    "type": "invoke",
    "range": 1,

    "canTarget": canTarget,
    "getPriority": getSupportPriority,

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, PlotFlourishes.SwingBackMovement({
            "mark": 0,
            "unitKey": performer.key,
            "position": performer.position,
            "direction": direction,
        }))

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 200, "audio": {"triggerKey": "Unit:Attack"}})

        const intendedDistance = 2
        const ray = Stage.findCollisionInDirection({
            "stage": stage,
            "position": position,
            "direction": direction,
            "maxdistance": intendedDistance,
        })

        Step.add(step, {
            "mark": 0,
            "intent": {
                "type": "reposition",
                "positions": ray.castedPositions
            }
        })

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        if(ray.distance > 0) {
            Step.add(step, PlotFlourishes.PushedMovement({
                "mark": 200,
                "unitKey": target.key,
                "startPosition": ray.startPosition,
                "endPosition": ray.endPosition,
            }))
        } else {
            Step.add(step, PlotFlourishes.NudgedMovement({
                "mark": 200,
                "unitKey": target.key,
                "position": target.position,
                "direction": direction,
            }))
        }

        // if(ray.distance < intendedDistance) {
        //     const damage = intendedDistance - ray.distance
        //     Step.add(step, {
        //         "mark": 200,
        //         "unit": {
        //             "key": target.key,
        //             "health": target.health - damage
        //         },
        //     })
        //
        //     if(ray?.collision?.unit != undefined) {
        //         Step.add(step, {
        //             "mark": 200,
        //             "unit": {
        //                 "key": ray.collision.unit.key,
        //                 "health": ray.collision.unit.health - damage
        //             },
        //         })
        //     }
        // }

        return step
    }
}

skills["heal-every-turn"] = {
    "key": "heal-every-turn",
    "type": "at-start-of-my-turn",
    "isHidden": true,
    "range": 0,

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]
        if(performer.health < performer.maxhealth) {
            // Step.add(step, PlotFlourishes.Shudder({
            //     "unitKey": performer.key,
            //     "position": performer.position,
            //     "intensity": 0.05,
            // }))
            Step.add(step, {
                "mark": 0,
                "unit": {
                    "key": performerKey,
                    "health": Math.min(performer.health + 10, performer.maxhealth),
                }
            })
            Step.add(step, PlotFlourishes.TextFloat({
                "mark": 10,
                "type": "healing",
                "unitKey": performer.key,
                "position": performer.position,
                "text": "+10hp",
            }))
        }

        return step
    }
}

skills["armor-every-turn"] = {
    "key": "armor-every-turn",
    "type": "at-start-of-my-turn",
    "isHidden": true,
    "range": 0,

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]
        Step.add(step, {
            "mark": 0,
            "unit": {
                "key": performerKey,
                "armor": performer.armor + 40,
            }
        })
        Step.add(step, PlotFlourishes.TextFloat({
            "mark": 10,
            "type": "healing",
            "unitKey": performer.key,
            "position": performer.position,
            "text": "+10🛡️",
        }))

        return step
    }
}

import("@fae/source/data/games/index.js").then((games) => {
    games = games.default
    if(games != undefined) {
        Object.values(games).forEach((game) => {
            if(game == undefined) return
            if(game.skills != undefined) {
                Object.keys(game.skills).forEach((skillKey) => {
                    skills[skillKey] = game.skills[skillKey]
                })
            }
        })
    }
})

export default skills
